import gql from 'graphql-tag'
import { graphql, ChildProps } from 'react-apollo'
import { ProjectCaseType } from '../../actions/project'

export const CASE_QUERY = gql`
  query Case($caseId: ID!) {
    case(id: $caseId) {
      id
      projectId
      thumbnail
      name
      description
      lastReport
      lastResults
      spaceType
      parameters
      data
    }
  }
`

export type CaseResponse = {
  case: ProjectCaseType
}

type CaseInput = { caseId?: string; skipCase?: boolean }

// tslint:disable-next-line
type CaseChildProps = ChildProps<any, ProjectCaseType | null>

export const withCase = graphql<CaseResponse, CaseInput, CaseChildProps>(
  CASE_QUERY,
  {
    options: props => ({ variables: { caseId: props.caseId } }),
    props: props => (props.data ? { projectCase: props.data.case } : null),
    skip: props => !props.caseId || props.skipCase
  }
)



// WEBPACK FOOTER //
// ./src/Components/Results/caseQuery.ts